import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { BytesPipe } from './pipes/data/data.bytes.pipe';
import { BoolPipe } from './pipes/data/data.bool.pipe';
import { CoalescePipe } from './pipes/data/data.coalesce.pipe';
import { OrderByPipe } from './pipes/data/data.order.by.pipe';

import { ActivityActionPipe } from './pipes/activity/activity.action.pipe';
import { ActivityDescriptionPipe } from './pipes/activity/activity.description.pipe';
import { ActivityFooterTextPipe } from './pipes/activity/activity.footer-text.pipe';
import { ActivityGlyphSectionPipe } from './pipes/activity/activity.glyph-section.pipe';
import { ActivityImageClassPipe } from './pipes/activity/activity.image-class.pipe';
import { ActivityItemStatePipe } from './pipes/activity/activity.item-state.pipe';
import { ActivitySectionStatePipe } from './pipes/activity/activity.section-state.pipe';
import { ActivityTitleDetailPipe } from './pipes/activity/activity.title-detail.pipe';
import { ActivityTitlePipe } from './pipes/activity/activity.title.pipe';
import { ActivityUserStatePipe } from './pipes/activity/activity.user-state.pipe';

import { DateGfRelativeDatePipe } from './pipes/date/date.relative-date.pipe';
import { DateGfDatePipe } from './pipes/date/date.gf-date.pipe';
import { DateGfToDatePipe } from './pipes/date/date.gf-to-date.pipe';
import { DateGfUtcDatePipe } from './pipes/date/date.gf-utc-date.pipe';

import { TextTabsToSpacesPipe } from './pipes/text/text.tabs-to-spaces.pipe';
import { TextNl2brPipe } from './pipes/text/nl2br.pipe';
import { LimitTextPipe } from './pipes/text/limit-text.pipe';
import { RawHtmlPipe } from './pipes/text/raw-html.pipe';
import { HtmlToPlainTextPipe } from './pipes/text/html-text.pipe';
import { NumberedLinesPipe } from './pipes/text/line-numbers.pipe';
import { PreWrapPipe } from './pipes/text/pre-wrap.pipe';
import { TranslatePipe } from './pipes/text/translate.pipe';
import { TranslateDirective } from './pipes/text/translate.directive';
import { TruncatePipe } from './pipes/text/truncate.pipe';
import { TextEscapeCodePipe } from './pipes/text/text.escape-code.pipe';
import { Md2htmlPipe } from './pipes/text/md2html.pipe';

import { UserAvatarPipe } from './pipes/user/user.avatar.pipe';
import { UserAvatarUrlPipe } from './pipes/user/user.avatar-url.pipe';
import { UserFullNamePipe } from './pipes/user/user.fullname.pipe';

import { LimitToPipe } from './pipes/limit-to.pipe';

import { RenderTiLinksPipe } from '../core/pipes/tracker-item/ti-links.pipe';

import { SearchResultStatePipe } from './pipes/search/search.result-state.pipe';
import { SearchResultParamsPipe } from './pipes/search/search.result-params.pipe';
import { SearchResultUrlPipe } from './pipes/search/search.result-url.pipe';

import { EfErrorMessagePipe } from './pipes/ef.error.message.pipe';
import { ObjectEntriesPipe } from './pipes/object/object.entries.pipe';
import { UrlLinkPipe } from './pipes/text/url-links.pipe';
import { KeyValuePipe } from './pipes/keyvalue.pipe';

@NgModule({
    imports: [
        BrowserModule
    ],
    providers: [
        BoolPipe,
        BytesPipe,
        CoalescePipe,
        ActivityActionPipe,
        ActivityDescriptionPipe,
        ActivityFooterTextPipe,
        ActivityGlyphSectionPipe,
        ActivityImageClassPipe,
        ActivityItemStatePipe,
        ActivitySectionStatePipe,
        ActivityTitleDetailPipe,
        ActivityTitlePipe,
        ActivityUserStatePipe,
        DateGfRelativeDatePipe,
        DateGfDatePipe,
        DateGfToDatePipe,
        DateGfUtcDatePipe,
        TextTabsToSpacesPipe,
        UserAvatarPipe,
        UserAvatarUrlPipe,
        UserFullNamePipe,
        TextNl2brPipe,
        LimitToPipe,
        LimitTextPipe,
        RawHtmlPipe,
        NumberedLinesPipe,
        PreWrapPipe,
        TranslatePipe,
        TranslateDirective,
        TruncatePipe,
        OrderByPipe,
        RenderTiLinksPipe,
        SearchResultParamsPipe,
        SearchResultStatePipe,
        SearchResultUrlPipe,
        TextEscapeCodePipe,
        EfErrorMessagePipe,
        Md2htmlPipe,
        ObjectEntriesPipe,
        UrlLinkPipe,
        KeyValuePipe,
    ],
    declarations: [
        BoolPipe,
        BytesPipe,
        CoalescePipe,
        ActivityActionPipe,
        ActivityDescriptionPipe,
        ActivityFooterTextPipe,
        ActivityGlyphSectionPipe,
        ActivityImageClassPipe,
        ActivityItemStatePipe,
        ActivitySectionStatePipe,
        ActivityTitleDetailPipe,
        ActivityTitlePipe,
        ActivityUserStatePipe,
        DateGfRelativeDatePipe,
        DateGfDatePipe,
        DateGfToDatePipe,
        DateGfUtcDatePipe,
        TextTabsToSpacesPipe,
        UserAvatarPipe,
        UserAvatarUrlPipe,
        UserFullNamePipe,
        TextNl2brPipe,
        LimitToPipe,
        LimitTextPipe,
        RawHtmlPipe,
        HtmlToPlainTextPipe,
        NumberedLinesPipe,
        PreWrapPipe,
        TranslatePipe,
        TranslateDirective,
        TruncatePipe,
        OrderByPipe,
        RenderTiLinksPipe,
        SearchResultParamsPipe,
        SearchResultStatePipe,
        SearchResultUrlPipe,
        TextEscapeCodePipe,
        EfErrorMessagePipe,
        Md2htmlPipe,
        ObjectEntriesPipe,
        UrlLinkPipe,
        KeyValuePipe,
    ],
    exports: [
        BoolPipe,
        BytesPipe,
        CoalescePipe,
        ActivityActionPipe,
        ActivityDescriptionPipe,
        ActivityFooterTextPipe,
        ActivityGlyphSectionPipe,
        ActivityImageClassPipe,
        ActivityItemStatePipe,
        ActivitySectionStatePipe,
        ActivityTitleDetailPipe,
        ActivityTitlePipe,
        ActivityUserStatePipe,
        DateGfRelativeDatePipe,
        DateGfDatePipe,
        DateGfToDatePipe,
        DateGfUtcDatePipe,
        TextTabsToSpacesPipe,
        UserAvatarPipe,
        UserAvatarUrlPipe,
        UserFullNamePipe,
        TextNl2brPipe,
        LimitToPipe,
        LimitTextPipe,
        RawHtmlPipe,
        HtmlToPlainTextPipe,
        NumberedLinesPipe,
        PreWrapPipe,
        TranslatePipe,
        TranslateDirective,
        TruncatePipe,
        OrderByPipe,
        RenderTiLinksPipe,
        SearchResultParamsPipe,
        SearchResultStatePipe,
        SearchResultUrlPipe,
        TextEscapeCodePipe,
        EfErrorMessagePipe,
        Md2htmlPipe,
        ObjectEntriesPipe,
        UrlLinkPipe,
        KeyValuePipe,
    ]
})
export class CoreFiltersModule {
    constructor() { }
}
